<template>
  <div
    v-outside-click="hideComment"
    class="kk-designer__comment"
    :style="{ left: `${left}px`, top: `${top}px`, transform }"
  >
    <textarea
      v-if="visibleComment.editMode"
      ref="comment"
      :value="cell.comment"
      @blur="save($event.target.value)"
      @keydown.escape.prevent="hideComment"
    >
    </textarea>
    <pre v-else>{{ cell.comment }}</pre>
  </div>
</template>

<script>
import { ColumnLetterHeight, RowNumberWidth } from "../../../utils/constants";
import DesignerMixin from "../DesignerMixin";
import { splitCellId } from "./Utils";

export default {
  mixins: [DesignerMixin],
  props: ["getPxFromRowIndex", "getPxFromColumnIndex"],
  data() {
    return {
      left: 0,
      top: 0,
      transform: "unset",
      commentId: null,
    };
  },
  computed: {
    visibleComment() {
      return this.$store.state.cells.visibleComment;
    },
    cellsMetaData() {
      return this.$store.state.cells.current?.design.cellsMetaData;
    },
    cell() {
      return this.cellsMetaData[this.visibleComment.id] || {};
    },
  },
  watch: {
    visibleComment(newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.calculatePosition();
      }
    },
  },
  mounted() {
    this.calculatePosition();
    this.$refs.comment?.focus({ preventScroll: true });
    this.setTransform();
  },
  methods: {
    calculatePosition() {
      const container = document.querySelector(".table-content");
      const commentBox = document.querySelector(".kk-designer__comment").getBoundingClientRect();
      const containerBound = container.getBoundingClientRect();

      const [rowId, columnId] = splitCellId(this.visibleComment.id);
      const [columnIndex, rowIndex] = this.getCellIndexById(this.visibleComment.id);
      let yPosition =
        this.getPxFromRowIndex(rowIndex) +
        this.getRawHeight(rowId) +
        ColumnLetterHeight +
        containerBound.top -
        container.scrollTop;
      let xPosition;
      if (this.mergedCellIds[this.visibleComment.id]) {
        xPosition =
          this.getPxFromColumnIndex(columnIndex) +
          this.getMergedCellWidth(this.mergedCellIds[this.visibleComment.id]) +
          RowNumberWidth +
          containerBound.left -
          container.scrollLeft;
      } else {
        xPosition =
          this.getPxFromColumnIndex(columnIndex) +
          this.getRawWidth(columnId) +
          RowNumberWidth +
          containerBound.left -
          container.scrollLeft;
      }

      if (xPosition + commentBox.width > window.innerWidth) {
        xPosition -= commentBox.width + this.getRawWidth(columnId);
      }

      if (yPosition + commentBox.height > window.innerHeight) {
        yPosition -= commentBox.height + this.getRawHeight(rowId);
      }

      this.left = xPosition;
      this.top = yPosition;
    },
    hideComment() {
      this.commentId = this.visibleComment.id;
      this.$store.dispatch("cells/setComment", { id: null, editMode: false });
    },
    save(value) {
      this.$store.dispatch("cells/editCellComment", {
        id: this.visibleComment.id ?? this.commentId,
        key: "comment",
        value,
      });
    },
    setTransform() {
      const tableContent = document.querySelector(".table-content");
      const parentRect = tableContent.getBoundingClientRect();
      const boundElement = this.$el.getBoundingClientRect();

      const translateX = boundElement.right > window.innerWidth - boundElement.width ? "-100%" : "0";
      const translateY = boundElement.bottom > window.innerHeight - boundElement.height ? "-140%" : "0";
      this.transform = `translate(${translateX},${translateY})`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.kk-designer__comment {
  position: fixed;
  height: 120px;
  width: 200px;
  background: @kk-color-light-gold;
  z-index: 70;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  padding: 8px;
  border: 1px solid black;
  border-radius: 5px;
  & textarea {
    padding: 0.3rem;
    line-height: 1.2;
    width: 100%;
    height: 100%;
    outline: none;
    resize: none;
    color: inherit;
    overflow: hidden;
  }
  & pre {
    width: 100%;
    height: 100%;
    font-family: inherit;
    white-space: pre-wrap;
  }
}
</style>
